import type { MenuItem, MenuLinkItem } from 'shared/components/navbar/types/menu-item'

export const isMenuLink = (item: MenuItem): item is MenuLinkItem => 'href' in item
